import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "POS Sales by Products";
const description = `The "POS Sales by Products" report is a key tool for businesses to analyze product performance by showing a history of what and how much has been sold. This report provides a detailed breakdown of each product's sales, including total revenue and units sold, allowing a business to quickly identify its best-selling items and those that are underperforming. By tracking this data, a company can make smarter decisions about inventory management, pricing, and promotional strategies.`;

const images = [
    '/images/reports/pos-sales/pos-sales-by-products/pos-sales-by-products.png', // 0
];


const PosSalesByProducts: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PosSalesByProducts;
